/**
 * -----------------------------------------------------------------------------
 * Popup - Camera Video
 * -----------------------------------------------------------------------------
 * This popup is used for Camera Video
 */

import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../api/store/commonSlice";
import { TCameraVideoProps } from "./type";
import { AdminFormFieldSubmit } from "../../components/admin/formFields";
import { useLoggedInUserData } from "../../utils/user";
import { ACCOUNT_RECORDER_TYPE_VALUES } from "../admin-details/account/constants";
import { CameraEventGetVideoDetailResponseVideos } from "../../api/types/Camera";

type TModalCameraVideo = TCameraVideoProps & {
  vmData?: CameraEventGetVideoDetailResponseVideos;
  onClose?: () => void;
};

const ModalCameraVideo: FC<TModalCameraVideo> = ({ data, vmData, onClose }) => {
  const { t } = useTranslation("translation", { keyPrefix: "vehicleMap" });
  const { t: tMain } = useTranslation("translation");
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );
  const dispatch = useDispatch();
  const thisOrgCameraRecorderType = useLoggedInUserData("cameraRecorderType");
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const userIsImpersonated = useSelector(
    (state: { commonReducer: { userIsImpersonated: boolean } }) =>
      state.commonReducer.userIsImpersonated
  );

  const filteredData = data?.recording?.video_data?.filter((item) =>
    thisOrgCameraRecorderType === ACCOUNT_RECORDER_TYPE_VALUES.VISIONMAX
      ? item.attachtype === "video/mp4" // deprecated method, now we use vmData
      : true
  );

  const finalVideoSrc =
    !!vmData?.videos && vmData?.videos?.length > 0
      ? vmData?.videos.map((video) => video.video_url)
      : filteredData?.map((item) => item.attachdata) || [];

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showVehicleCameraVideo: false }));
    if (onClose) onClose();
  };

  if (modalsState?.showVehicleCameraVideo === false) return null;

  return (
    <>
      <div className="justify-center items-start flex overflow-x-hidden overflow-y-auto fixed inset-0 z-overlay outline-none focus:outline-none">
        <div
          className="fixed w-full h-screen bg-modal-overlay z-overlay"
          onClick={hideModal}
        ></div>
        <div className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-full max-h-[calc(100vh-10rem)] z-modal">
          <div className="p-8 bg-white gap-6 rounded-3xl shadow-2xl">
            <div className="grid grid-cols-12 gap-4 justify-between items-center">
              <div className="flex flex-col gap-4 col-span-2">
                {finalVideoSrc?.map((video, index) => (
                  <AdminFormFieldSubmit
                    key={index}
                    type="button"
                    variant={
                      selectedIndex === index ? "primary-like" : "secondary"
                    }
                    buttonDimensionClass="h-auto w-full px-2 py-3"
                    label={t("video_camera_n", { number: index + 1 })}
                    onClick={() => setSelectedIndex(index)}
                  />
                ))}
                <hr />
                <AdminFormFieldSubmit
                  type="button"
                  variant={"secondary"}
                  buttonDimensionClass="h-auto w-full px-2 py-3"
                  label={tMain("close")}
                  onClick={() => hideModal()}
                />
              </div>
              <div
                className={`col-span-10 ${userIsImpersonated ? "h-[calc(100vh-7rem-40px)]" : "h-[calc(100vh-7rem)]"} relative flex flex-row items-center justify-center`}
              >
                <video
                  className="absolute max-h-full max-w-full"
                  controls
                  key={selectedIndex}
                >
                  <source
                    key={selectedIndex}
                    type="video/mp4"
                    src={`${
                      thisOrgCameraRecorderType ===
                      ACCOUNT_RECORDER_TYPE_VALUES.SURFSIGHT
                        ? "data:video/mp4;base64,"
                        : ""
                    }${finalVideoSrc?.[selectedIndex]}`}
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ModalCameraVideo;
